import { genericService } from '../_utilities/generic';
import api from '../_api';

const extendedProductService = (pathname) => ({
  ...genericService(pathname),
  getFacets(args, cancel) {
    return api.get('/facets/', {
      params: args,
      signal: cancel ? cancel.signal : null,
    });
  },
  getSortingValues() {
    return api.get('/sortvalues/');
  },
});

export default extendedProductService;
